import { Header } from "./Header";
import { HeroSection } from "./HeroSection";
import { ServicesSection } from "./ServicesSection";
import { DataStore365Section } from "./DataStore365Section";
import { PortfolioSection } from "./PortfolioSection";
import { ContactSection } from "./ContactSection";
import { Footer } from "./Footer";
import { Toaster } from "../ui/sonner";

export default function LandingPage() {
  return (
    <div className="min-h-screen bg-[#050510]">
      <Header />
      <HeroSection />
      <ServicesSection />
      <DataStore365Section />
      <PortfolioSection />
      <ContactSection />
      <Footer />
      <Toaster
        position="bottom-right"
        toastOptions={{
          style: {
            background: "#0e0e20",
            border: "1px solid rgba(255,255,255,0.06)",
            color: "#fff",
          },
        }}
      />
    </div>
  );
}
